export default __webpack_public_path__ + "static/media/AT.9acfac7b.svg";